const widgetType = {
    SUBMISSIONS : 1,

    TASKS : 2,

    URL : 3,

    RECENT_ACTIVITY : 4

};

angular.module('gw-um-j2js')
    .constant('widgetType', widgetType);